import { render, staticRenderFns } from "./BomFormInline.vue?vue&type=template&id=4622e63b&scoped=true"
import script from "./BomFormInline.vue?vue&type=script&lang=js"
export * from "./BomFormInline.vue?vue&type=script&lang=js"
import style0 from "./BomFormInline.vue?vue&type=style&index=0&id=4622e63b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4622e63b",
  null
  
)

export default component.exports